/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
*/

/* eslint-disable wf-security/no-location-href */
import { execute } from '../../native-app-bridge/native-app-bridge';
import globals from '../../globals/globals';
import logger from '../../logger/logger';

var nativeNavigation = function nativeNavigation(options) {
  var _globals = globals(),
      _globals$rootContextP = _globals.rootContextPath,
      rootContextPath = _globals$rootContextP === void 0 ? '' : _globals$rootContextP,
      _globals$keepAlivePat = _globals.keepAlivePath,
      keepAlivePath = _globals$keepAlivePat === void 0 ? 'keepAlive' : _globals$keepAlivePat;

  var navigationOptions = {
    url: options.navigationItem.url,
    type: options.nativeNavigationType,
    navigationType: options.nativeNavigationType,
    keepAliveUrl: window.location.origin + rootContextPath + keepAlivePath,
    // eslint-disable-next-line
    onCloseExecute: options.onCloseExecute || 'javascript:window.dispatchKeepAlive'
  };

  if (options.displayType === 'atm') {
    logger.debug("Calling native ATM navigation: ".concat(navigationOptions.url));
    execute('atm', navigationOptions);
  } else {
    logger.debug("Calling native openUrl navigation: ".concat(navigationOptions.url));
    execute('openUrl', navigationOptions);
  } // After calling execute or navigate, the M2 version triggers the 'mwfAfterNativeAction' on
  // the document. I can't find a handler for this event anywhere in our M2 codebase.
  // $(document).trigger('mwfAfterNativeAction', navigationOptions)

};

export default nativeNavigation;